// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icons/viewby_tile_inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/icons/viewby_tile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/icons/viewby_list_inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/icons/viewby_list.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/icons/viewby_calendar_inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/icons/viewby_calendar.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/icons/viewby_ilt_inactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/icons/viewby_ilt.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout for assignments page header */
.assignmentsHeader {
  border-bottom: 2px solid black;
  padding-bottom: 1rem;
  flex-direction: row;
  display: flex;
  align-items: baseline;
  margin: 0px -15px;
}

.assignmentsHeader h2 {
  padding-left: 2rem;
  margin-top: 3rem;
}

/* viewBy area */
div.viewBy span {
  color: black;
  font-size: 16px;
}

a.viewTile {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 1.5rem;
  height: 1.5rem;
  background-size: contain;
  display: inline-block;
}

a.viewTile.selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  width: 1.5rem;
  height: 1.5rem;
  background-size: contain;
  display: inline-block;
}

a.viewList {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 2rem;
  height: 1.5rem;
  background-size: cover;
  display: inline-block;
}

a.viewList.selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  width: 2rem;
  height: 1.5rem;
  background-size: cover;
  display: inline-block;
}

a.viewCalendar {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  width: 2rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
}

a.viewCalendar.selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
}

a.viewILT {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  width: 3rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
}

a.viewILT.selected {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  width: 3rem;
  height: 2rem;
  background-size: contain;
  display: inline-block;
  background-repeat: no-repeat;
}

/* filterby area */
.filterBy {
  padding: 2rem;
  font-size: 16px;
  display: flex;
}

.filterBy a {
  /* Yet another override. */
  font-size: 16px;
}

.filterBy span.filterHelpText {
  margin-right: 2rem;
}

.filterBy .filterHelpText {
  color: black;
  font-weight: bold;
}

.filterBy .filterItem + .filterItem:before {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.filterBy .filterItem a {
  color: black;
}

.filterBy span.selected a {
  font-weight: bold;
}

div.users div.viewBy {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.users .templateSwitcher {
  list-style: none;
}

.users .templateSwitcher li {
  display: inline;
}

.filters {
  margin-bottom: 15px;
  padding: 0px;
}

.filters.col-md-4 {
  text-align: right;
}

.filters .assignmentFilter {
  color: #000;
  cursor: pointer;
  font-size: 16px;
  margin-right: 7px;
}

.filters.col-md-4 .assignmentFilter {
  margin-left: 7px;
}

.filters .assignmentFilter:hover {
  text-decoration: none;
}

/**
* Manager css
*/
.manFlyout {
  border-top: 1px solid #313131;
  left: 15px;
  top: 30px;
}

#advManagerSearchFilter .body {
  width: 100%;
}

/*student dashboard*/
#studentDash .summary .summaryHeader {
  font-weight: bold;
  font-size: 16px;
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

#studentDash .summary {
  background-color: #f5f5f5;
  padding-left: 2rem;
  padding-right: 2rem;
}

#studentDash .summaryExpander {
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
  padding-top: 2rem;
  padding-bottom: 1.5rem;
}

#studentDash .summary .summaryRow .summaryBox {
  width: 16rem;
  padding-top: 1.5rem;
  padding-bottom: 1rem;
  background-color: white;
  border: 1px solid black;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#studentDash .summary .summaryRow {
  display: flex;
  justify-content: flex-begin;
  margin-top: 55px;
}

#studentDash .summary .summaryRow .summaryBox .amount {
  font-weight: bold;
  font-size: 26px;
  text-align: center;
}

#studentDash .summaryRows {
  padding-right: 45px;
}

.assignmentsHeader > .datePickerHolder {
  padding-right: 2rem;
}

#studentDash .summary .summaryPieChart .chartBody .chartLegend {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding-left: 6rem;
  padding-bottom: 1rem;
}

#studentDash .summary .summaryPieChart .chartBody {
  display: flex;
}

#studentDash .summary .summaryPieChart .chartBody .chartLegend .amount {
  font-weight: bold;
  font-size: 24px;
  display: block;
  margin-bottom: -0.7rem;
}

#studentDash .summary .summaryPieChart .chartBody .chartLegend .title {
  font-weight: bold;
  font-size: 12px;
  display: block;
}

#studentDash .incomplete {
  color: #d6d6d6;
}

#studentDash .complete {
  color: #009ce6;
}

#studentDash .overdue {
  color: #f63f3f;
}

#studentDash .chartLegend .row {
  background-color: white;
  border: solid black 1px;
  margin-top: 3px;
  margin-bottom: 3px;
  width: 10rem;
  text-align: center;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
}

#studentDash .assignmentsHeader {
  justify-content: space-between;
}

#studentDash .summaryPieChartContainer {
  padding-top: 10px;
}

/* Tabbed navigation */
ul.bai-tab-nav {
  list-style: none;
  padding-left: 0;
  margin: 0;
  border-bottom-width: 3px;
  border-bottom-style: solid;
  border-bottom-color: #00a1de;
}

ul.bai-tab-nav li:last-child {
  margin-left: -5px;
}

ul.bai-tab-nav li {
  display: inline-block;
  border-top: 1px #000000 solid;
  border-left: 1px #000000 solid;
  border-right: 1px #000000 solid;
  font-size: 14px;
}

ul.bai-tab-nav li.active {
  border-top-width: 1px;
  border-top-style: solid;
  border-right-width: 1px;
  border-right-style: solid;
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: #00a1de;
  border-right-color: #00a1de;
  border-top-color: #00a1de;
  background-color: #00a1de;
}

ul.bai-tab-nav li > a {
  color: #000000;
  font-size: 14px;
  text-decoration: none;
  display: block;
  padding: 1rem 5rem;
}

ul.bai-tab-nav li.active > a {
  color: #ffffff;
  font-weight: 700;
}

inProgressContainer {
  margin-top: 25px;
  margin-bottom: 25px;
}

#studentDash .inProgressContainer .inProgressSummaryContainer {
  font-size: 1.25em;
  margin-left: 25px;
}

.inProgressSummaryHeader {
  margin-top: 50px;
  font-weight: bold;
}

.inProgressRow {
  margin-top: 25px;
  margin-bottom: 25px;
  border-bottom: 3px solid white;
  padding-bottom: 15px;
}

.doughnutPercentage {
  position: absolute;
  top: 47%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  font-size: 1.3em;
  text-align: center;
}

.summaryHeader {
  border-bottom: 3px solid white;
  padding-bottom: 10px;
}

.administratorDashboard .summary .summaryRow {
  margin-bottom: 55px;
}

.administratorDashboard {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 0px;
  padding-right: 0px;
}

.dashboardContent {
  border-top: 2px solid black;
  padding-left: 15px;
  padding-right: 15px;
}

.dashboardContent .spinnerLoading {
  width: 100%;
}

.dashboardContent .spinner {
  margin: 0px;
  width: auto !important;
}

.dashboardContent .summary {
  padding-right: 0px !important;
}

#careerPathKey {
  padding-top: 10px;
  padding-left: 240px;
}

#careerPathKey .cpKeyRow {
  display: inline-flex;
  width: 100%;
}

#careerPathKey .careerPathColorBox {
  width: 20px;
  height: 20px;
  padding-right: 20px;
  margin-right: 5px;
}

#careerPathKey .careerPathKeyName {
  padding-top: 2px;
}

#chartjs-tooltip {
  opacity: 0;
  position: absolute;
  background-color: white;
  padding: 10px;
  border-radius: 3px;
  -webkit-transition: all 0.1s ease;
  transition: all 0.1s ease;
  pointer-events: none;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
  width: 150px;
  border: solid #e5e5e5 2px;
  z-index: 10;
}

.myProgressContainer {
  background-color: #00375d;
  color: #ffffff;
  margin-top: 20px;
  overflow: hidden;
  background-clip: content-box;
}

.progressTitle {
  height: 10px;
  margin: 10px 0px 10px 10px;
  font-size: 16px;
  font-weight: bold;
}

.myProgressContainer .title {
  font-size: 16px;
  text-align: center;
  font-family: 'Verdana', 'Arial', 'sans-serif';
}

.myProgressContainer .summaryBox:first-of-type {
  border-bottom: solid;
  border-bottom-color: #ffffff;
  border-bottom-width: thin;
  padding-bottom: 6px;
  margin-bottom: 6px;
  margin-top: 20px;
}

.myProgressContainer .col-sm-3 {
  margin: 16px 16px 16px 20px;
  max-height: 180px;
  max-width: 191px;
}

.myProgressContainer .summarySection {
  padding: 40px 0px 0px 50px;
  font-size: 20px;
  font-weight: bold;
}

.myProgressContainer .summarySection .amount {
  font-size: 24px;
}

.myProgressContainer .amount {
  font-size: 16px;
  font-weight: bolder;
  display: inline-block;
  width: 51px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/users/users.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mDAAqE;EACrE,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mDAA4D;EAC5D,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mDAAqE;EACrE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mDAA4D;EAC5D,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mDAAyE;EACzE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mDAAgE;EAChE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mDAAoE;EACpE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mDAA2D;EAC3D,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;CAEC;AACD;EACE,6BAA6B;EAC7B,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb","sourcesContent":["/* Layout for assignments page header */\n.assignmentsHeader {\n  border-bottom: 2px solid black;\n  padding-bottom: 1rem;\n  flex-direction: row;\n  display: flex;\n  align-items: baseline;\n  margin: 0px -15px;\n}\n\n.assignmentsHeader h2 {\n  padding-left: 2rem;\n  margin-top: 3rem;\n}\n\n/* viewBy area */\ndiv.viewBy span {\n  color: black;\n  font-size: 16px;\n}\n\na.viewTile {\n  background: url('../../assets/images/icons/viewby_tile_inactive.svg');\n  width: 1.5rem;\n  height: 1.5rem;\n  background-size: contain;\n  display: inline-block;\n}\n\na.viewTile.selected {\n  background: url('../../assets/images/icons/viewby_tile.svg');\n  width: 1.5rem;\n  height: 1.5rem;\n  background-size: contain;\n  display: inline-block;\n}\n\na.viewList {\n  background: url('../../assets/images/icons/viewby_list_inactive.svg');\n  width: 2rem;\n  height: 1.5rem;\n  background-size: cover;\n  display: inline-block;\n}\n\na.viewList.selected {\n  background: url('../../assets/images/icons/viewby_list.svg');\n  width: 2rem;\n  height: 1.5rem;\n  background-size: cover;\n  display: inline-block;\n}\n\na.viewCalendar {\n  background: url('../../assets/images/icons/viewby_calendar_inactive.svg');\n  width: 2rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n}\n\na.viewCalendar.selected {\n  background: url('../../assets/images/icons/viewby_calendar.svg');\n  width: 2rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n}\n\na.viewILT {\n  background: url('../../assets/images/icons/viewby_ilt_inactive.svg');\n  width: 3rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\na.viewILT.selected {\n  background: url('../../assets/images/icons/viewby_ilt.svg');\n  width: 3rem;\n  height: 2rem;\n  background-size: contain;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\n/* filterby area */\n.filterBy {\n  padding: 2rem;\n  font-size: 16px;\n  display: flex;\n}\n\n.filterBy a {\n  /* Yet another override. */\n  font-size: 16px;\n}\n\n.filterBy span.filterHelpText {\n  margin-right: 2rem;\n}\n\n.filterBy .filterHelpText {\n  color: black;\n  font-weight: bold;\n}\n\n.filterBy .filterItem + .filterItem:before {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.filterBy .filterItem a {\n  color: black;\n}\n\n.filterBy span.selected a {\n  font-weight: bold;\n}\n\ndiv.users div.viewBy {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.users .templateSwitcher {\n  list-style: none;\n}\n\n.users .templateSwitcher li {\n  display: inline;\n}\n\n.filters {\n  margin-bottom: 15px;\n  padding: 0px;\n}\n\n.filters.col-md-4 {\n  text-align: right;\n}\n\n.filters .assignmentFilter {\n  color: #000;\n  cursor: pointer;\n  font-size: 16px;\n  margin-right: 7px;\n}\n\n.filters.col-md-4 .assignmentFilter {\n  margin-left: 7px;\n}\n\n.filters .assignmentFilter:hover {\n  text-decoration: none;\n}\n\n/**\n* Manager css\n*/\n.manFlyout {\n  border-top: 1px solid #313131;\n  left: 15px;\n  top: 30px;\n}\n\n#advManagerSearchFilter .body {\n  width: 100%;\n}\n\n/*student dashboard*/\n#studentDash .summary .summaryHeader {\n  font-weight: bold;\n  font-size: 16px;\n  margin-top: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n#studentDash .summary {\n  background-color: #f5f5f5;\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n#studentDash .summaryExpander {\n  display: flex;\n  justify-content: center;\n  background-color: #f5f5f5;\n  padding-top: 2rem;\n  padding-bottom: 1.5rem;\n}\n\n#studentDash .summary .summaryRow .summaryBox {\n  width: 16rem;\n  padding-top: 1.5rem;\n  padding-bottom: 1rem;\n  background-color: white;\n  border: 1px solid black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n#studentDash .summary .summaryRow {\n  display: flex;\n  justify-content: flex-begin;\n  margin-top: 55px;\n}\n\n#studentDash .summary .summaryRow .summaryBox .amount {\n  font-weight: bold;\n  font-size: 26px;\n  text-align: center;\n}\n\n#studentDash .summaryRows {\n  padding-right: 45px;\n}\n\n.assignmentsHeader > .datePickerHolder {\n  padding-right: 2rem;\n}\n\n#studentDash .summary .summaryPieChart .chartBody .chartLegend {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-end;\n  padding-left: 6rem;\n  padding-bottom: 1rem;\n}\n\n#studentDash .summary .summaryPieChart .chartBody {\n  display: flex;\n}\n\n#studentDash .summary .summaryPieChart .chartBody .chartLegend .amount {\n  font-weight: bold;\n  font-size: 24px;\n  display: block;\n  margin-bottom: -0.7rem;\n}\n\n#studentDash .summary .summaryPieChart .chartBody .chartLegend .title {\n  font-weight: bold;\n  font-size: 12px;\n  display: block;\n}\n\n#studentDash .incomplete {\n  color: #d6d6d6;\n}\n\n#studentDash .complete {\n  color: #009ce6;\n}\n\n#studentDash .overdue {\n  color: #f63f3f;\n}\n\n#studentDash .chartLegend .row {\n  background-color: white;\n  border: solid black 1px;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  width: 10rem;\n  text-align: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem;\n}\n\n#studentDash .assignmentsHeader {\n  justify-content: space-between;\n}\n\n#studentDash .summaryPieChartContainer {\n  padding-top: 10px;\n}\n\n/* Tabbed navigation */\nul.bai-tab-nav {\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n  border-bottom-width: 3px;\n  border-bottom-style: solid;\n  border-bottom-color: #00a1de;\n}\n\nul.bai-tab-nav li:last-child {\n  margin-left: -5px;\n}\n\nul.bai-tab-nav li {\n  display: inline-block;\n  border-top: 1px #000000 solid;\n  border-left: 1px #000000 solid;\n  border-right: 1px #000000 solid;\n  font-size: 14px;\n}\n\nul.bai-tab-nav li.active {\n  border-top-width: 1px;\n  border-top-style: solid;\n  border-right-width: 1px;\n  border-right-style: solid;\n  border-left-width: 1px;\n  border-left-style: solid;\n  border-left-color: #00a1de;\n  border-right-color: #00a1de;\n  border-top-color: #00a1de;\n  background-color: #00a1de;\n}\n\nul.bai-tab-nav li > a {\n  color: #000000;\n  font-size: 14px;\n  text-decoration: none;\n  display: block;\n  padding: 1rem 5rem;\n}\n\nul.bai-tab-nav li.active > a {\n  color: #ffffff;\n  font-weight: 700;\n}\n\ninProgressContainer {\n  margin-top: 25px;\n  margin-bottom: 25px;\n}\n\n#studentDash .inProgressContainer .inProgressSummaryContainer {\n  font-size: 1.25em;\n  margin-left: 25px;\n}\n\n.inProgressSummaryHeader {\n  margin-top: 50px;\n  font-weight: bold;\n}\n\n.inProgressRow {\n  margin-top: 25px;\n  margin-bottom: 25px;\n  border-bottom: 3px solid white;\n  padding-bottom: 15px;\n}\n\n.doughnutPercentage {\n  position: absolute;\n  top: 47%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  font-size: 1.3em;\n  text-align: center;\n}\n\n.summaryHeader {\n  border-bottom: 3px solid white;\n  padding-bottom: 10px;\n}\n\n.administratorDashboard .summary .summaryRow {\n  margin-bottom: 55px;\n}\n\n.administratorDashboard {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.dashboardContent {\n  border-top: 2px solid black;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.dashboardContent .spinnerLoading {\n  width: 100%;\n}\n\n.dashboardContent .spinner {\n  margin: 0px;\n  width: auto !important;\n}\n\n.dashboardContent .summary {\n  padding-right: 0px !important;\n}\n\n#careerPathKey {\n  padding-top: 10px;\n  padding-left: 240px;\n}\n\n#careerPathKey .cpKeyRow {\n  display: inline-flex;\n  width: 100%;\n}\n\n#careerPathKey .careerPathColorBox {\n  width: 20px;\n  height: 20px;\n  padding-right: 20px;\n  margin-right: 5px;\n}\n\n#careerPathKey .careerPathKeyName {\n  padding-top: 2px;\n}\n\n#chartjs-tooltip {\n  opacity: 0;\n  position: absolute;\n  background-color: white;\n  padding: 10px;\n  border-radius: 3px;\n  -webkit-transition: all 0.1s ease;\n  transition: all 0.1s ease;\n  pointer-events: none;\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  width: 150px;\n  border: solid #e5e5e5 2px;\n  z-index: 10;\n}\n\n.myProgressContainer {\n  background-color: #00375d;\n  color: #ffffff;\n  margin-top: 20px;\n  overflow: hidden;\n  background-clip: content-box;\n}\n\n.progressTitle {\n  height: 10px;\n  margin: 10px 0px 10px 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.myProgressContainer .title {\n  font-size: 16px;\n  text-align: center;\n  font-family: 'Verdana', 'Arial', 'sans-serif';\n}\n\n.myProgressContainer .summaryBox:first-of-type {\n  border-bottom: solid;\n  border-bottom-color: #ffffff;\n  border-bottom-width: thin;\n  padding-bottom: 6px;\n  margin-bottom: 6px;\n  margin-top: 20px;\n}\n\n.myProgressContainer .col-sm-3 {\n  margin: 16px 16px 16px 20px;\n  max-height: 180px;\n  max-width: 191px;\n}\n\n.myProgressContainer .summarySection {\n  padding: 40px 0px 0px 50px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.myProgressContainer .summarySection .amount {\n  font-size: 24px;\n}\n\n.myProgressContainer .amount {\n  font-size: 16px;\n  font-weight: bolder;\n  display: inline-block;\n  width: 51px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
